/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _2 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>2 - Ванильный CSS или SASS</h2>
    <CopyBlock
      text={`/* Button.css */
.Button {
  display: inline-flex;
  margin: 0 4px;
  padding: 8px 24px;
  border: 0;
  border-radius: 2px;
  color: #ffffff;
  font-size: 14px;
  font-family: inherit;
  background-color: #2196f3;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
}

.Button:hover,
.Button:focus {
  background-color: #1976d2;
}

.Button-disabled {
  background-color: #0000001f;
  color: #00000042;
}`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <p className={styles.description} />
    <CopyBlock
      text={`// Button.js
import './Button.css';

const Button = ({ type = 'button', label, disabled }) => {
  const btnClasses = ['Button'];

  if (disabled) {
    btnClasses.push('Button-disabled');
  }

  return (
    <button type={type} disabled={disabled} className={btnClasses.join(' ')}>
      {label}
    </button>
  );
};`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <ul className={styles.list}>
      <li className={styles.list__item}>Ванильный CSS не масштабируется</li>
      <li className={styles.list__item}>Глобальное пространство имен</li>
      <li className={styles.list__item}>Приходится использовать BEM-нотацию</li>
      <li className={styles.list__item}>Вложенность селекторов без BEM</li>
      <li className={styles.list__item}>Проблематичное удаление мертвого кода</li>
    </ul>
  </section>
))
